// extracted by mini-css-extract-plugin
export default {"login":"Login-module__login--EXb2t","link":"Login-module__link--Efckr","white-background":"Login-module__white-background--kycc6","sticky":"Login-module__sticky--BPCEF"};